<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.startDate"
              type="date"
              placeholder="选择签到开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.endDate"
              type="date"
              placeholder="选择签到结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @ignore="ignoreFun(arguments)"
        @del="delFun(arguments)"
        @export="batchExport(masterList)"
        @exportZip="batchExportZip(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 导出 batchExportZipMixin
import batchExportZipMixin2 from '@/mixin/batchExportZipMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 获取操作用户信息
import { getUserInfo } from "@/utils/auth"
// API
import { loadStoreVisitCheckInListDataApi, exportStoreVisitCheckInListDataApi, exportStoreVisitCheckInImgZipApi, ignoreStoreVisitCheckInApi, deleteStoreVisitCheckInApi } from '@/api/v2/storeVisitCheckIn';

export default {
  name: 'StoreVisitCheckInView',
  components: {
    CustomTable2,
    TableOperation2
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2, batchExportZipMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_visit_check_in_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          // {
          //   permissionSigns: ['store_visit_check_in_edit'],
          //   prop: 'edit',
          //   label: '忽略',
          //   method: 'ignore'
          // },
          {
            permissionSigns: ['store_visit_check_in_del'],
            prop: 'del',
            label: '作废',
            method: 'del'
          },
          {
            permissionSigns: ['store_visit_check_in_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['store_visit_check_in_export'],
            prop: 'exportZip',
            label: '导出图片',
            method: 'exportZip'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 20,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          storeName: '',
          certificateNo: '',
          startDate: '',
          endDate: '',
          userId: null
        }
      },
      id: null,
      baseUrl: process.env.VUE_APP_FILE_V2_API,
      nasUrl: process.env.VUE_APP_NAS_API
    }
  },
  created () {
    let _this = this;
    let user = JSON.parse(getUserInfo());
    _this.masterList.tableQuery.userId = user.type === 2 ? user.id : null;

    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'ifnull(tsi.province_name, \'\')', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'ifnull(tsi.city_name, \'\')', width: 100 },
      { prop: 'countyName', label: '区县', filterColumn: 'ifnull(tsi.county_name, \'\')', width: 120 },
      { prop: 'storeName', label: '拜访对象', filterColumn: 'ifnull(tsi.store_name, tsvci.visit_user)', width: 180 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'ifnull(tsi.certificate_no, "")', width: 130 },
      { prop: 'isStoreValue', label: '是否关联零售户', filterColumn: '(case tsvci.is_store when 1 then "是" else "否" end)', width: 140 },
      { prop: 'visitorName', label: '签到人', filterColumn: 'tu.name', width: 100 },
      { prop: 'visitDate', label: '签到时间', filterColumn: 'tsvci.visit_date', width: 150 },
      { prop: 'visitAddress', label: '签到地点', filterColumn: 'tsvci.visit_address', width: 200 },
      { prop: 'pic', label: '图片', width: 700, isImage: true },
      { prop: 'remark', label: '备注', filterColumn: 'tsvci.remark', width: 200 },
      { prop: 'isReportValue', label: '是否拜访报告', filterColumn: '(case tsvci.is_report when 1 then "是" else "否" end)', width: 130 },
      { prop: 'isIgnoreValue', label: '是否忽略', filterColumn: '(case tsvci.is_ignore when 1 then "是" else "否" end)', width: 120 },
      { prop: 'ignoreOperatorName', label: '忽略人', filterColumn: 'tsvci.ignore_operator_name', width: 120 },
      { prop: 'ignoreOperationTime', label: '忽略时间', filterColumn: 'tsvci.ignore_operation_time', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      let nasYearMonth = Number(new Date().getFullYear() - 1) + '12'
      loadStoreVisitCheckInListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        let dataList = data.list || [];
        dataList.forEach(item => {
          let pic = []
          if (item.imageUrls && item.imageUrls.length > 0) {
            item.imageUrls.split(',').forEach(url => {
              let yearMonth = url.split('/')[2].substring(0,6)
              if(Number(nasYearMonth) > Number(yearMonth)){
                pic.push(_this.nasUrl + url)
              } else {
                pic.push(_this.baseUrl +'/'+ url)
              }
            })
          }
          item.pic = pic
        })
        _this.handleData(dataList);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    // 忽略操作
    ignoreFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要忽略的签到记录', type: 'warning' })
        return
      }
      _this.$confirm('是否确定忽略该签到信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        ignoreStoreVisitCheckInApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '忽略成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 作废操作
    delFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的签到记录', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该签到信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteStoreVisitCheckInApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportStoreVisitCheckInListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    },
    // 导出数据API
    exportZipByPage () {
      let _this = this;
      exportStoreVisitCheckInImgZipApi(_this.exportZipObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
